import axios from "axios";

export const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

// Глобально: все запросы шлют cookie
axios.defaults.withCredentials = true;

// ========== AUTH ==========
export const register = (userData) => axios.post(`${API_BASE}/auth/register`, userData);
export const login = (credentials) => axios.post(`${API_BASE}/auth/login`, credentials);
export const getCurrentUser = () => axios.get(`${API_BASE}/auth/me`);

export const logout = async () => {
  try {
    await axios.post(`${API_BASE}/auth/logout`);
  } catch (err) {
    console.error("Logout error:", err);
  }
  // localStorage больше не используем для токена,
  // но если там лежит user — можно почистить
  localStorage.removeItem('user');
};

// ========== SMTP ACCOUNTS ==========
export const getSmtpAccounts = () => axios.get(`${API_BASE}/smtp-accounts`);
export const addSmtpAccount = (account) => axios.post(`${API_BASE}/smtp-accounts`, account);
export const addSmtpAccountsBulk = (accounts) =>
  axios.post(`${API_BASE}/smtp-accounts/bulk`, { accounts });
export const deleteSmtpAccounts = (ids) =>
  axios.post(`${API_BASE}/smtp-accounts/delete`, { ids });

// ========== RECIPIENTS ==========
export const getRecipients = () => axios.get(`${API_BASE}/recipients`);
export const addRecipient = (recipient) => axios.post(`${API_BASE}/recipients`, recipient);

// ========== SEND EMAIL ==========
export const sendEmail = (data) => axios.post(`${API_BASE}/send`, data);

// ========== CONSENT ==========
export const getLegalDocuments = () => axios.get(`${API_BASE}/consent/documents`);
export const postCookieConsent = (payload) => axios.post(`${API_BASE}/consent/cookie`, payload);
export const getMyConsents = () => axios.get(`${API_BASE}/consent/me`);

// ========== TEMPLATES ==========
export const getTemplates = () => axios.get(`${API_BASE}/api/templates`);
export const createTemplate = (data) => axios.post(`${API_BASE}/api/templates`, data);
export const updateTemplate = (id, data) => axios.put(`${API_BASE}/api/templates/${id}`, data);
export const deleteTemplate = (id) => axios.delete(`${API_BASE}/api/templates/${id}`);